import React from 'react'
import UserWorkflows from './userWorkflows'

function index() {
  return (
    <UserWorkflows />
  )
}

export default index